// Libraries
import React from 'react';
import { Formik } from 'formik';
// Components
import { Button } from '@components/button';
import { CheckBox } from '@components/input';
import { Modal } from '@components/modal';
// Models
import { IModalPoliticalDataProps } from '../models/ModalConditionsProps';
// Constants
import { NOMINA_EN_LINEA_PRODUCT, TypeDocumentNames } from '@constants/Onboarding';
// Assets
import logo from '@assets/logos/logo-nav-green.png';

export const ModalPoliticalData: React.FC<IModalPoliticalDataProps> = ({
    showFreeDemoDocument,
    handleOpenDocument,
    handleSubmitDocuments = (): void => {},
}) => {
    return (
        <Formik initialValues={{ data_processing: false, free_demo: false }} onSubmit={(): void => {}}>
            {({ values }): JSX.Element => (
                <Modal isOpen closeIcon={false} className="modal-term" disabledOverlay>
                    <div className="modal-term__container">
                        <img src={logo} className="image-width" />
                        {showFreeDemoDocument && (
                            <div className="modal-term__container--text">
                                No logramos completar tu solicitud. Lee y acepta los siguientes documentos.
                            </div>
                        )}
                        {!showFreeDemoDocument && (
                            <div className="modal-term__container--text">
                                Para continuar usando nuestra plataforma lee y autoriza la actualización de nuestro Tratamiento de
                                Datos Personales
                            </div>
                        )}
                        <div className="modal-term__container--check">
                            <div>
                                <CheckBox name="data_processing" checked={values.data_processing} />
                            </div>
                            <div>
                                He leído y autorizo el&nbsp;
                                <span
                                    onClick={(): void =>
                                        handleOpenDocument(TypeDocumentNames.DATA_PROCESSING, NOMINA_EN_LINEA_PRODUCT)
                                    }
                                >
                                    Tratamiento de Datos Personales.
                                </span>
                            </div>
                        </div>
                        {showFreeDemoDocument && (
                            <div className="modal-term__container--check">
                                <div>
                                    <CheckBox name="free_demo" checked={values.free_demo} />
                                </div>
                                <div>
                                    He leído y acepto la&nbsp;
                                    <span
                                        onClick={(): void =>
                                            handleOpenDocument(TypeDocumentNames.FREE_DEMO, NOMINA_EN_LINEA_PRODUCT)
                                        }
                                    >
                                        Declaración de Uso Gratuito del Producto.
                                    </span>
                                </div>
                            </div>
                        )}
                        <div className="modal-term__button-container">
                            <Button
                                onClick={handleSubmitDocuments}
                                disabled={!values.data_processing || (showFreeDemoDocument && !values.free_demo)}
                            >
                                Aceptar
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
        </Formik>
    );
};
